/* VORTRIX — cart drawer: countdown de escassez + upsells selecionáveis.
   Standalone, sem depender dos módulos ESM do Horizon. */
(function () {
  'use strict';

  /* ---------------------------------------------------------- countdown ---
     Persiste o horário-fim por sessão (localStorage) → conta pra baixo de
     verdade, não reseta a cada abertura. Ao zerar, reinicia. */
  var DURATION = 15 * 60 * 1000;      // 15 min
  var KEY = 'vx_cart_deadline';

  function deadline() {
    var d = 0;
    try { d = parseInt(localStorage.getItem(KEY) || '0', 10); } catch (e) {}
    var now = Date.now();
    if (!d || d <= now) {
      d = now + DURATION;
      try { localStorage.setItem(KEY, String(d)); } catch (e) {}
    }
    return d;
  }

  function tick() {
    var el = document.querySelector('[data-vx-countdown]');
    if (!el) return;
    var rem = Math.max(0, deadline() - Date.now());
    var m = Math.floor(rem / 60000);
    var s = Math.floor((rem % 60000) / 1000);
    el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }
  setInterval(tick, 1000);
  tick();

  /* ------------------------------------------------------------- upsells ---
     Delegação no document (sobrevive à troca de innerHTML do drawer). */
  var busy = false;

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-vx-toggle]');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('[data-vx-upsell]');
    if (!card || busy) return;

    var vid = parseInt(card.getAttribute('data-variant'), 10);
    if (!vid) return;
    var on = card.classList.contains('is-on');

    busy = true;
    card.classList.add('is-busy');
    /* feedback otimista imediato */
    card.classList.toggle('is-on');
    btn.classList.toggle('is-on');

    var opts = { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } };
    var req;
    if (on) {
      opts.body = JSON.stringify({ id: String(vid), quantity: 0, sections: 'cart-drawer-section' });
      req = fetch('/cart/change.js', opts);
    } else {
      opts.body = JSON.stringify({ items: [{ id: vid, quantity: 1 }], sections: 'cart-drawer-section' });
      req = fetch('/cart/add.js', opts);
    }

    req.then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data.sections && data.sections['cart-drawer-section'];
        if (html) swapDrawer(html);
        updateBubble();
        busy = false;
      })
      .catch(function () {
        /* reverte o otimismo se falhar */
        card.classList.toggle('is-on');
        btn.classList.toggle('is-on');
        card.classList.remove('is-busy');
        busy = false;
      });
  });

  /* Troca só o miolo do drawer (preserva o <dialog> aberto). Os custom
     elements internos re-hidratam sozinhos no connectedCallback. */
  function swapDrawer(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.cart-drawer__inner');
    var cur = document.querySelector('.cart-drawer__inner');
    if (fresh && cur) {
      cur.innerHTML = fresh.innerHTML;
      tick();
    }
  }

  /* Atualiza o número do carrinho no header (best-effort). */
  function updateBubble() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = cart.item_count;
        var sel = '.cart-bubble__count, [ref="cartBubbleCount"], [data-cart-count], .cart-count, .header__cart-count';
        document.querySelectorAll(sel).forEach(function (el) { el.textContent = n; });
      })
      .catch(function () {});
  }
})();
